import { render, staticRenderFns } from "./ModalWaste.vue?vue&type=template&id=0881e559&"
import script from "./ModalWaste.vue?vue&type=script&lang=js&"
export * from "./ModalWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports